export default __webpack_public_path__ + "static/sol-healthcare-section-4-img-2dde8efdbbc4cdd4a79aac98959e3230.png";